import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const F = ({ label, children }) => <div><Label className="text-xs">{label}</Label>{children}</div>;

export function HoldForm({ form, setForm, onSubmit }) {
  return (
    <div className="border border-border rounded-md p-3 space-y-2" data-testid="otd-hold-form">
      <F label="Hold reason *"><Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="otd-hold-reason" /></F>
      <F label="Expected resume date"><Input type="date" value={form.expected_resume_date} onChange={(e) => setForm({ ...form, expected_resume_date: e.target.value })} data-testid="otd-hold-resume-date" /></F>
      <Button size="sm" className="bg-signal-amber text-black" disabled={!form.reason.trim()}
        onClick={() => onSubmit({ ...form, expected_resume_date: form.expected_resume_date || null })} data-testid="otd-hold-submit">Confirm On Hold</Button>
    </div>
  );
}

export function ReopenForm({ reason, setReason, onSubmit }) {
  return (
    <div className="border border-border rounded-md p-3 space-y-2" data-testid="otd-reopen-form">
      <F label="Reopen reason *"><Input value={reason} onChange={(e) => setReason(e.target.value)} data-testid="otd-reopen-reason" placeholder="e.g. Output incomplete, customer requires changes" /></F>
      <Button size="sm" className="bg-signal-amber text-black" disabled={!reason.trim()} onClick={() => onSubmit({ reason })} data-testid="otd-reopen-submit">Confirm Reopen</Button>
    </div>
  );
}

const ARCHIVE_REASONS = [["test", "Test Task"], ["demo_training", "Demo / Training"], ["duplicate", "Duplicate"],
  ["incorrect", "Incorrectly Created"], ["no_longer_required", "No Longer Required"], ["other", "Other"]];

export function ArchiveForm({ form, setForm, onSubmit }) {
  return (
    <div className="border border-signal-red/40 rounded-md p-3 space-y-2" data-testid="otd-archive-form">
      <F label="Archive reason *">
        <select className="w-full h-9 rounded-md border border-input bg-background px-2 text-xs" value={form.reason}
          onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="otd-archive-reason">
          {ARCHIVE_REASONS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        </select>
      </F>
      {form.reason === "other" && (
        <F label="Explanation *"><Input value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} data-testid="otd-archive-remarks" /></F>)}
      <Button size="sm" className="bg-signal-red text-white" disabled={form.reason === "other" && !form.remarks.trim()}
        onClick={() => onSubmit({ reason: form.reason, remarks: form.remarks || null })} data-testid="otd-archive-submit">Confirm Archive</Button>
    </div>
  );
}

export function BlockForm({ form, setForm, onSubmit }) {
  return (
    <div className="border border-border rounded-md p-3 space-y-2" data-testid="otd-block-form">
      <F label="Reason *"><Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="otd-block-reason" /></F>
      <F label="Waiting for (person / department) *"><Input value={form.waiting_on} onChange={(e) => setForm({ ...form, waiting_on: e.target.value })} data-testid="otd-block-waiting" /></F>
      <F label="Expected resolution date"><Input type="date" value={form.expected_resolution} onChange={(e) => setForm({ ...form, expected_resolution: e.target.value })} data-testid="otd-block-expected" /></F>
      <Button size="sm" className="bg-signal-amber text-black" disabled={!form.reason || !form.waiting_on}
        onClick={() => onSubmit({ ...form, expected_resolution: form.expected_resolution || null })} data-testid="otd-block-submit">Confirm Blocked</Button>
    </div>
  );
}
